const $win = $(window);
const $doc = $(document);

import 'slick-carousel';
import 'magnific-popup';

// Slick Carousel
$('.slider .slider__slides').slick({
    arrows: false,
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    pauseOnDotsHover: false,
    pauseOnFocus:false,
    pauseOnHover:false,
    initialSlide: 0,
    autoplaySpeed: 3000
});

setTimeout(function(){
    $('.slider .slider__slides').slick('slickPlay');
}, 1000);

// Magnific Popup
$('.link-popup').magnificPopup({
    type: 'ajax'
});

// Mobile Navigation
$('.btn-menu').on('click', function(event) {
    event.preventDefault();

    $('.nav').toggleClass('open');
});

// Styicky Header
$win.on("scroll",function(){
    var scroll = $win.scrollTop();

    if(scroll>1){
        $(".header").addClass('fixed');
    } else {
        $(".header").removeClass('fixed');
    };
});






// Cache selectors
var lastId,
    topMenu = $(".nav"),
    topMenuHeight = topMenu.outerHeight()-40,
    // All list items
    menuItems = topMenu.find("a:not(.external)"),
    // Anchors corresponding to menu items
    scrollItems = menuItems.map(function(){
        var item = $($(this).attr("href"));
        if (item.length) { return item; }
    });

// Bind click handler to menu items
// so we can get a fancy scroll animation
menuItems.click(function(e){
    var href = $(this).attr("href"),
        offsetTop = href === "#" ? 0 : $(href).offset().top-topMenuHeight+1;
    $('html, body').stop().animate({
        scrollTop: offsetTop
    }, 300);
    e.preventDefault();
});

// Bind to scroll
$(window).scroll(function(){
    // Get container scroll position
    var fromTop = $(this).scrollTop()+topMenuHeight;

    // Get id of current scroll item
    var cur = scrollItems.map(function(){
        if ($(this).offset().top < fromTop)
            return this;
    });
    // Get the id of the current element
    cur = cur[cur.length-1];
    var id = cur && cur.length ? cur[0].id : "";

    if (lastId !== id) {
        lastId = id;
        // Set/remove active class
        menuItems
            .parent().removeClass("active")
            .end().filter("[href='#"+id+"']").parent().addClass("active");
    }
});

$('.ajax-form').on('submit', function(e) {
    e.preventDefault();

    let $self = $(this);
    let loading = $self.data('ajaxLoading');
    if ( loading === 'yes' ) {
        return;
    }

    $self.data('ajaxLoading', 'yes');

    doAjax($self)
        .always(() => {
            grecaptcha.reset();
            $self.data('ajaxLoading', 'no');
        });
});

function doAjax($form) {
    let data = $form.serializeArray();
    let $loader = $form.find('.lds-hourglass');

    return $.ajax( {
        url: 'lib/contact.php',
        type: 'POST',
        data: data,
        beforeSend: () => {
            $loader.show();
            $form.find('.field').removeClass('error');
            $form.find('.field-error').hide();
        },
        success: (response, text, jQxhr) => {
            if ( response.status === 'success' ) {
                alert(response.message);
                $form[0].reset();
            } else if ( response.status === 'error-generic' ) {
                alert(response.message);
            } else {
                $.each(response.errors, function(key, val){
                    $form.find('#field-' + key).addClass('error');
                    $form.find('#error-' + key).show();
                });
            }

            return this;
        }
    } )
        .always(() => {
            $loader.hide();
        });
}


// WEBPACK FOOTER //
// ../src/assets/js/main.js